<div class="d-grid form-group">
  <label class="col-form-label" [ngClass]="{required: required}">
    {{ label }}
  </label>

  <mat-form-field
    [appearance]="appearance"
    [floatLabel]="floatLabel"
    subscriptSizing="dynamic"
    class="gw-datepicker-field"
  >
    <!-- MODO SINGLE -->
    <ng-container *ngIf="mode === 'single'; else rangeTpl">
      <div class="d-flex align-items-center field-date">
        <input
          matInput
          [matDatepicker]="picker"
          [placeholder]="placeholderText"
          [matDatepickerFilter]="$any(matDatepickerFilter)"
          [min]="$any(min)"
          [max]="$any(max)"
          [disabled]="disabled"
          [value]="displayValue"
          (dateChange)="onSingleInputChange($event)"
          (blur)="onBlur()"
          [attr.aria-required]="required"
        />
        <mat-datepicker
          #picker="matDatepicker"
          [startAt]="startAt"
        ></mat-datepicker>
        <mat-datepicker-toggle matSuffix [for]="picker">
          <gatewee-icon
            matDatepickerToggleIcon
            icon="@tui.calendar"
            iconStyle="primary"
            size="20px"
            class="custom-datepicker-icon"
          ></gatewee-icon>
        </mat-datepicker-toggle>
      </div>
    </ng-container>

    <!-- MODO RANGE -->
    <ng-template #rangeTpl>
      <mat-date-range-input
        [rangePicker]="rangePicker"
        [disabled]="disabled"
        (dateChange)="onRangeInputChange($event)"
        (blur)="onBlur()"
        [separator]="' – '"
      >
        <input matStartDate [placeholder]="'dd/mm/aaaa'" [value]="start" />
        <input matEndDate [placeholder]="'dd/mm/aaaa'" [value]="end" />
      </mat-date-range-input>
      <mat-icon matSuffix>event</mat-icon>
      <mat-date-range-picker
        #rangePicker
        [startAt]="startAt"
      ></mat-date-range-picker>
    </ng-template>
  </mat-form-field>

  <error-message
    [form]="form"
    [controlName]="controlName"
    [customMessages]="customMessages"
  ></error-message>
</div>
